import URL from '../url'
import Request from '../request'

/**
 *
 * @param {*} priceId
 */
export const createStripeSessionService = (priceId, trialDays, successReturnUrl, toltReferral) =>
  new Request(URL.API, URL.PAYMENT_SESSION).post({
    priceId,
    successReturnUrl,
    ...(trialDays != null ? { trialDays } : {}),
    ...(toltReferral != null ? { toltReferral } : {}),
  })
